import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { TipoPromocaoCampanhaModule } from '../../../promocao/tipo';
import { CampanhaClienteFormModule } from '../clientes';
import { CampanhaItemFormModule } from '../itens';
import { CampanhaPromocaoFormComponent } from './campanha-promocao-form.component';

@NgModule({
    imports: [
        SharedModule,
        TipoPromocaoCampanhaModule,
        CampanhaClienteFormModule,
        CampanhaItemFormModule
    ],
    declarations: [
        CampanhaPromocaoFormComponent
    ],
    exports: [
        CampanhaPromocaoFormComponent
    ]
})
export class CampanhaPromocaoFormModule { }
